import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsc_inline_edit_fast_follow_field_types');
	},
};
